// Validator for IMD percentage fields (0-100)
import { createFieldValueValidator } from '../helpers'

export const fieldValueValidator = createFieldValueValidator(100)
